// extracted by mini-css-extract-plugin
module.exports = {"class_t":"header_class_t__3l_40","class_header":"header_class_header__gsuX8","class_t_text":"header_class_t_text__2JI9q","class_text":"header_class_text__2_r0a"};